import { render, staticRenderFns } from "./CloseRouteVersion.vue?vue&type=template&id=fded8642&"
import script from "./CloseRouteVersion.vue?vue&type=script&lang=js&"
export * from "./CloseRouteVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports